import React from "react";
import { SignupForm } from "./components/signup/SignUpForm";
import "./styles/Auth.module.css";

export const Signup = () => {
  return (
    <div className="auth-container">
      <div className="auth-form">
        <SignupForm />
      </div>
    </div>
  );
};

